import { render, staticRenderFns } from "./ProcessImage.vue?vue&type=template&id=47575da2"
import script from "./ProcessImage.vue?vue&type=script&lang=js"
export * from "./ProcessImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports